<template>
  <div v-if="aboutUsDetail" class="px-30">
    <p class="py-6">{{ aboutUsDetail.title }}</p>
    <!-- <p class="text-left shrink"> -->
    <p class="text-left">  
      {{ delHtmlTag(aboutUsDetail.content) }}
    </p>
  </div>
</template>
<script>
import { ref, onMounted } from "@vue/composition-api";
export default {
  setup(props, ctx) {
    const aboutUsDetail = ref();
    onMounted(async () => {
      const res = await ctx.root.$callapi("news/getNewsDetail", {
        tag: "aboutus",
      });
      aboutUsDetail.value = res.data;
    });
    //去除html 标签
    const delHtmlTag = (str) => {
      return str.replace(/<[^>]+>/g, "");
    };
    return { aboutUsDetail, delHtmlTag };
  },
};
</script>
<style scoped lang="scss">
.shrink {
  text-indent: 2em;
}
</style>